import { create } from 'zustand'

interface ITab {
  label: string
  value: string
  content: React.ReactNode
  defaultActive: boolean
  isDisabled: boolean
}

interface IUseLessonTabStore {
  currentTab: string
  tabs: ITab[]
  setCurrentTab: (tab: string) => void
  setTabs: (tabs: ITab[]) => void
}

export const useLessonTabStore = create<IUseLessonTabStore>((set, get) => ({
  currentTab: 'description',
  tabs: [],
  setCurrentTab: (tab) => {
    const { tabs } = get()
    const validTab = tabs.find((t) => t.value === tab && !t.isDisabled)

    if (validTab) {
      set({ currentTab: tab })
    } else {
      const firstEnabledTab = tabs.find((t) => !t.isDisabled)
      if (firstEnabledTab) {
        set({ currentTab: firstEnabledTab.value })
      }
    }
  },
  setTabs: (tabs) => {
    set({ tabs })

    const defaultTab = tabs.find((t) => t.defaultActive && !t.isDisabled)
    const firstEnabledTab = tabs.find((t) => !t.isDisabled)

    if (defaultTab) {
      set({ currentTab: defaultTab.value })
    } else if (firstEnabledTab) {
      set({ currentTab: firstEnabledTab.value })
    }
  },
}))
